import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '16px',
    backgroundColor: 'secondary.main',
    borderRadius: '10px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: 'common.grey850',
  },
  userTypeChip: {
    backgroundColor: 'primary.light',
    color: 'common.grey350',
  },
  email: {
    fontSize: 14,
    fontWeight: '500',
    color: 'grey.500',
    overflowWrap: 'anywhere',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
